import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IlClass } from '@queries/generated';
import { SidebarToggleComponent } from '../sidebar-toggle/sidebar-toggle.component';

@Component({
  selector: 'vnm-checkout-bookable-class',
  templateUrl: './checkout-bookable-class.component.html',
  styleUrls: ['./checkout-bookable-class.component.scss']
})
export class CheckoutBookableClassComponent {
  @Input() ilClass: IlClass;
  @Output() selectedClass = new EventEmitter<IlClass>();

  constructor(private translateService: TranslateService, private sidebarToggle: SidebarToggleComponent) {}

  get buttonLabel(): string {
    return this.translateService.instant(
      this.ilClass.availableSeats ? 'checkout-bookable-class.book-now' : 'checkout-bookable-class.join-waitlist'
    );
  }

  onSelectClass() {
    this.selectedClass.emit(this.ilClass);
    this.sidebarToggle.close();
  }
}
